/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */

export type UserPayloadDtoLabelRole =
  (typeof UserPayloadDtoLabelRole)[keyof typeof UserPayloadDtoLabelRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPayloadDtoLabelRole = {
  OWNER: "OWNER",
  MEMBER: "MEMBER",
  ARTIST: "ARTIST",
} as const;
